import { PersonLane } from './types';

/** Earliest `from` across face and voice intervals; `Infinity` when both are empty. */
export function firstAppearanceMs(lane: PersonLane): number {
  const starts = [...lane.face, ...lane.voice].map((a) => a.from);
  return starts.length === 0 ? Infinity : Math.min(...starts);
}

/**
 * Sorts lanes by first appearance in the (already clipped) window, ascending.
 * Tie-breaks on `laneKey` for a stable order while scrubbing.
 */
export function byFirstAppearance(a: PersonLane, b: PersonLane): number {
  const diff = firstAppearanceMs(a) - firstAppearanceMs(b);
  return diff !== 0 ? diff : a.laneKey.localeCompare(b.laneKey);
}
